import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import { Tooltip } from "@mui/material";
import React, { CSSProperties, useEffect, useMemo, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "@common-reducers/hooks/store.hook";

import { checkIfReplyingToMessageThunk, handleClickScheduleMessageThunk } from "@common/thunks/UserMessagesThunks";
import { Chat } from "@bt-common/interfaces/whatsapp-types";
import { UserMessage } from "@bt-common/schemas/bt/user-message";
import { User } from "@common-models/user";
import styles from "./add-scheduled-message-button.module.scss";

type AddScheduledMessageButtonProps = {
  isDisabled?: boolean;
  classes?: any;
  isSchedulePollButton?: boolean;
};

export type AddScheduledMessageButtonState = {
  open: boolean;
  message?: UserMessage;
  user?: User | null | undefined;
  showErrorDialog: boolean;
  currentChat?: Chat;
  isEmojiPicker: boolean;
};

export const AddScheduledMessageButton = (props: AddScheduledMessageButtonProps) => {
  const dispatch = useAppDispatch()
  const [isHovered, setIsHovered] = useState(false);

  const addButtonRef = useRef<HTMLDivElement>(null);

  const errorState = useAppSelector((state) => state.WhatsAppReducer.errorState);


  //remove css conflict from Li' emoji className
  //by adding the width and the height properties
  const reomoveClassNameConflict = () => {
    const styleTag = document.createElement("style");
    styleTag.innerText = `
    .emoji-picker-react .emoji {
      position: relative;
      width:auto;
      height:auto;
    } `;

    document.head.appendChild(styleTag);
  };

  useEffect(() => {
    reomoveClassNameConflict();
  }, [])

  const isDisabled = useMemo(() => localStorage.getItem("schedulerReady") !== "true" || errorState, [errorState]);

  const handleClickOpen = async () => {
    const clickStartTime = performance.now();
    console.log(`[Performance] Button clicked at ${clickStartTime.toFixed(2)}ms`);
    
    if (typeof performance !== 'undefined' && performance.mark) {
      performance.mark('schedule-dialog-button-click');
    }
    
    // Wait for checkIfReplyingToMessageThunk to complete instead of arbitrary 1 second delay
    const checkReplyStartTime = performance.now();
    const checkReplyResult = await dispatch(checkIfReplyingToMessageThunk());
    const checkReplyTime = performance.now() - checkReplyStartTime;
    console.log(`[Performance] checkIfReplyingToMessageThunk completed in ${checkReplyTime.toFixed(2)}ms`);

    const scheduleThunkStartTime = performance.now();
    dispatch(handleClickScheduleMessageThunk({ isSchedulePollButton: props.isSchedulePollButton ?? false }));
    const scheduleThunkTime = performance.now() - scheduleThunkStartTime;
    console.log(`[Performance] handleClickScheduleMessageThunk dispatched in ${scheduleThunkTime.toFixed(2)}ms`);
    
    const totalTime = performance.now() - clickStartTime;
    console.log(`[Performance] Total button click handler time: ${totalTime.toFixed(2)}ms`);
    
    if (typeof performance !== 'undefined' && performance.measure) {
      performance.measure('schedule-dialog-button-click-to-thunk', 'schedule-dialog-button-click');
    }
  };




  const { classes } = props;
  const buttonClasses = [styles?.alarmButton, classes?.alarmButton];
  if (isDisabled) {
    buttonClasses.push(classes?.disabled);
  }

  const baseButtonStyle = React.useMemo<CSSProperties>(() => ({
    border: 'none',
    background: 'transparent',
    width: 40,
    height: 40,
    borderRadius: '50%',
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }), []);

  return (
    <>
      <div
        ref={addButtonRef}
        className={classes?.addScheduleContainer}
        data-bt-feature="composerScheduleMessage"
      >
        <Tooltip title="Schedule a message" arrow placement="top">
          <div
            className={styles.hoverContainer}
            onClick={handleClickOpen}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <button
              aria-label="Schedule a message"
              className={buttonClasses.join(" ")}
              style={baseButtonStyle}
              type="button"
            >
              {isHovered ? <AccessTimeFilledIcon /> : <AccessTimeIcon />}
            </button>
          </div>
        </Tooltip>
      </div>
    </>
  );
}
